/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as PublicLegalRouteImport } from './routes/_public/_legal'
import { Route as PublicMapRouteImport } from './routes/_public/_map'
import { Route as AuthenticatedManagementIndexRouteImport } from './routes/_authenticated/management/index'
import { Route as AuthenticatedManagementOrganizationsRouteImport } from './routes/_authenticated/management/organizations'
import { Route as AuthenticatedManagementProfileRouteImport } from './routes/_authenticated/management/profile'
import { Route as AuthenticatedManagementStationlessRouteImport } from './routes/_authenticated/management/stationless'
import { Route as AuthenticatedManagementStationsRouteImport } from './routes/_authenticated/management/stations'
import { Route as AuthenticatedManagementUsersRouteImport } from './routes/_authenticated/management/users'
import { Route as PublicAuthenticationLoginRouteImport } from './routes/_public/_authentication/login'
import { Route as PublicMapIndexRouteImport } from './routes/_public/_map/index'
import { Route as PublicMapSidebarRouteImport } from './routes/_public/_map/_sidebar'
import { Route as AuthenticatedManagementOrganizationsIndexRouteImport } from './routes/_authenticated/management/organizations/index'
import { Route as AuthenticatedManagementOrganizationsOrganizationIdRouteImport } from './routes/_authenticated/management/organizations/$organizationId'
import { Route as AuthenticatedManagementOrganizationsCreateRouteImport } from './routes/_authenticated/management/organizations/create'
import { Route as AuthenticatedManagementProfileIndexRouteImport } from './routes/_authenticated/management/profile/index'
import { Route as AuthenticatedManagementStationlessIndexRouteImport } from './routes/_authenticated/management/stationless/index'
import { Route as AuthenticatedManagementStationlessParkAndRideFacilityIdRouteImport } from './routes/_authenticated/management/stationless/$parkAndRideFacilityId'
import { Route as AuthenticatedManagementStationlessCreateRouteImport } from './routes/_authenticated/management/stationless/create'
import { Route as AuthenticatedManagementStationsIndexRouteImport } from './routes/_authenticated/management/stations/index'
import { Route as AuthenticatedManagementStationsStationIdRouteImport } from './routes/_authenticated/management/stations/$stationId'
import { Route as AuthenticatedManagementStationsCreateRouteImport } from './routes/_authenticated/management/stations/create'
import { Route as AuthenticatedManagementUsersIndexRouteImport } from './routes/_authenticated/management/users/index'
import { Route as AuthenticatedManagementUsersUserIdRouteImport } from './routes/_authenticated/management/users/$userId'
import { Route as PublicAuthenticationInvitationAuthenticationTokenIdRouteImport } from './routes/_public/_authentication/invitation.$authenticationTokenId'
import { Route as PublicAuthenticationPasswordResetIndexRouteImport } from './routes/_public/_authentication/password-reset.index'
import { Route as PublicAuthenticationPasswordResetAuthenticationTokenIdRouteImport } from './routes/_public/_authentication/password-reset.$authenticationTokenId'
import { Route as AuthenticatedManagementOrganizationsOrganizationIdIndexRouteImport } from './routes/_authenticated/management/organizations/$organizationId/index'
import { Route as AuthenticatedManagementStationlessParkAndRideFacilityIdIndexRouteImport } from './routes/_authenticated/management/stationless/$parkAndRideFacilityId/index'
import { Route as AuthenticatedManagementStationlessParkAndRideFacilityIdAuditsRouteImport } from './routes/_authenticated/management/stationless/$parkAndRideFacilityId/audits'
import { Route as AuthenticatedManagementStationsStationIdIndexRouteImport } from './routes/_authenticated/management/stations/$stationId/index'
import { Route as AuthenticatedManagementStationsStationIdAuditsRouteImport } from './routes/_authenticated/management/stations/$stationId/audits'
import { Route as AuthenticatedManagementUsersUserIdIndexRouteImport } from './routes/_authenticated/management/users/$userId/index'
import { Route as PublicMapSidebarParkAndRideFacilitiesParkAndRideFacilityIdRouteImport } from './routes/_public/_map/_sidebar/park-and-ride-facilities.$parkAndRideFacilityId'
import { Route as PublicMapSidebarParkingFacilitiesParkingFacilityIdRouteImport } from './routes/_public/_map/_sidebar/parking-facilities.$parkingFacilityId'
import { Route as PublicMapSidebarPickupParkingFacilitiesPickupParkingFacilityIdRouteImport } from './routes/_public/_map/_sidebar/pickup-parking-facilities.$pickupParkingFacilityId'
import { Route as PublicMapSidebarStationsStationIdRouteImport } from './routes/_public/_map/_sidebar/stations.$stationId'
import { Route as AuthenticatedManagementOrganizationsOrganizationIdOrganizationUsersOrganizationUserIdRouteImport } from './routes/_authenticated/management/organizations/$organizationId/organizationUsers/$organizationUserId'
import { Route as AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdRouteImport } from './routes/_authenticated/management/stations/$stationId/park-and-ride-facilities/$parkAndRideFacilityId'
import { Route as AuthenticatedManagementStationsStationIdParkAndRideFacilitiesCreateRouteImport } from './routes/_authenticated/management/stations/$stationId/park-and-ride-facilities/create'
import { Route as AuthenticatedManagementOrganizationsOrganizationIdOrganizationUsersOrganizationUserIdIndexRouteImport } from './routes/_authenticated/management/organizations/$organizationId/organizationUsers/$organizationUserId/index'
import { Route as AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdIndexRouteImport } from './routes/_authenticated/management/stations/$stationId/park-and-ride-facilities/$parkAndRideFacilityId/index'
import { Route as AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdAuditsRouteImport } from './routes/_authenticated/management/stations/$stationId/park-and-ride-facilities/$parkAndRideFacilityId/audits'

const PublicLegalAboutLazyRouteImport = createFileRoute(
  '/_public/_legal/about',
)()
const PublicLegalAccessibilityLazyRouteImport = createFileRoute(
  '/_public/_legal/accessibility',
)()
const PublicLegalContactLazyRouteImport = createFileRoute(
  '/_public/_legal/contact',
)()
const PublicLegalFrequentlyAskedQuestionsLazyRouteImport = createFileRoute(
  '/_public/_legal/frequently-asked-questions',
)()
const PublicLegalImprintLazyRouteImport = createFileRoute(
  '/_public/_legal/imprint',
)()
const PublicLegalPrivacyLazyRouteImport = createFileRoute(
  '/_public/_legal/privacy',
)()
const PublicLegalTermsOfUseLazyRouteImport = createFileRoute(
  '/_public/_legal/terms-of-use',
)()

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicLegalRoute = PublicLegalRouteImport.update({
  id: '/_public/_legal',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicMapRoute = PublicMapRouteImport.update({
  id: '/_public/_map',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedManagementIndexRoute =
  AuthenticatedManagementIndexRouteImport.update({
    id: '/management/',
    path: '/management/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedManagementOrganizationsRoute =
  AuthenticatedManagementOrganizationsRouteImport.update({
    id: '/management/organizations',
    path: '/management/organizations',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedManagementProfileRoute =
  AuthenticatedManagementProfileRouteImport.update({
    id: '/management/profile',
    path: '/management/profile',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedManagementStationlessRoute =
  AuthenticatedManagementStationlessRouteImport.update({
    id: '/management/stationless',
    path: '/management/stationless',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedManagementStationsRoute =
  AuthenticatedManagementStationsRouteImport.update({
    id: '/management/stations',
    path: '/management/stations',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedManagementUsersRoute =
  AuthenticatedManagementUsersRouteImport.update({
    id: '/management/users',
    path: '/management/users',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const PublicAuthenticationLoginRoute =
  PublicAuthenticationLoginRouteImport.update({
    id: '/_public/_authentication/login',
    path: '/login',
    getParentRoute: () => rootRouteImport,
  } as any)
const PublicLegalAboutLazyRoute = PublicLegalAboutLazyRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => PublicLegalRoute,
} as any).lazy(() =>
  import('./routes/_public/_legal/about.lazy').then((d) => d.Route),
)
const PublicLegalAccessibilityLazyRoute =
  PublicLegalAccessibilityLazyRouteImport.update({
    id: '/accessibility',
    path: '/accessibility',
    getParentRoute: () => PublicLegalRoute,
  } as any).lazy(() =>
    import('./routes/_public/_legal/accessibility.lazy').then((d) => d.Route),
  )
const PublicLegalContactLazyRoute = PublicLegalContactLazyRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => PublicLegalRoute,
} as any).lazy(() =>
  import('./routes/_public/_legal/contact.lazy').then((d) => d.Route),
)
const PublicLegalFrequentlyAskedQuestionsLazyRoute =
  PublicLegalFrequentlyAskedQuestionsLazyRouteImport.update({
    id: '/frequently-asked-questions',
    path: '/frequently-asked-questions',
    getParentRoute: () => PublicLegalRoute,
  } as any).lazy(() =>
    import('./routes/_public/_legal/frequently-asked-questions.lazy').then(
      (d) => d.Route,
    ),
  )
const PublicLegalImprintLazyRoute = PublicLegalImprintLazyRouteImport.update({
  id: '/imprint',
  path: '/imprint',
  getParentRoute: () => PublicLegalRoute,
} as any).lazy(() =>
  import('./routes/_public/_legal/imprint.lazy').then((d) => d.Route),
)
const PublicLegalPrivacyLazyRoute = PublicLegalPrivacyLazyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => PublicLegalRoute,
} as any).lazy(() =>
  import('./routes/_public/_legal/privacy.lazy').then((d) => d.Route),
)
const PublicLegalTermsOfUseLazyRoute =
  PublicLegalTermsOfUseLazyRouteImport.update({
    id: '/terms-of-use',
    path: '/terms-of-use',
    getParentRoute: () => PublicLegalRoute,
  } as any).lazy(() =>
    import('./routes/_public/_legal/terms-of-use.lazy').then((d) => d.Route),
  )
const PublicMapIndexRoute = PublicMapIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PublicMapRoute,
} as any)
const PublicMapSidebarRoute = PublicMapSidebarRouteImport.update({
  id: '/_sidebar',
  getParentRoute: () => PublicMapRoute,
} as any)
const AuthenticatedManagementOrganizationsIndexRoute =
  AuthenticatedManagementOrganizationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedManagementOrganizationsRoute,
  } as any)
const AuthenticatedManagementOrganizationsOrganizationIdRoute =
  AuthenticatedManagementOrganizationsOrganizationIdRouteImport.update({
    id: '/$organizationId',
    path: '/$organizationId',
    getParentRoute: () => AuthenticatedManagementOrganizationsRoute,
  } as any)
const AuthenticatedManagementOrganizationsCreateRoute =
  AuthenticatedManagementOrganizationsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthenticatedManagementOrganizationsRoute,
  } as any)
const AuthenticatedManagementProfileIndexRoute =
  AuthenticatedManagementProfileIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedManagementProfileRoute,
  } as any)
const AuthenticatedManagementStationlessIndexRoute =
  AuthenticatedManagementStationlessIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedManagementStationlessRoute,
  } as any)
const AuthenticatedManagementStationlessParkAndRideFacilityIdRoute =
  AuthenticatedManagementStationlessParkAndRideFacilityIdRouteImport.update({
    id: '/$parkAndRideFacilityId',
    path: '/$parkAndRideFacilityId',
    getParentRoute: () => AuthenticatedManagementStationlessRoute,
  } as any)
const AuthenticatedManagementStationlessCreateRoute =
  AuthenticatedManagementStationlessCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthenticatedManagementStationlessRoute,
  } as any)
const AuthenticatedManagementStationsIndexRoute =
  AuthenticatedManagementStationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedManagementStationsRoute,
  } as any)
const AuthenticatedManagementStationsStationIdRoute =
  AuthenticatedManagementStationsStationIdRouteImport.update({
    id: '/$stationId',
    path: '/$stationId',
    getParentRoute: () => AuthenticatedManagementStationsRoute,
  } as any)
const AuthenticatedManagementStationsCreateRoute =
  AuthenticatedManagementStationsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthenticatedManagementStationsRoute,
  } as any)
const AuthenticatedManagementUsersIndexRoute =
  AuthenticatedManagementUsersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedManagementUsersRoute,
  } as any)
const AuthenticatedManagementUsersUserIdRoute =
  AuthenticatedManagementUsersUserIdRouteImport.update({
    id: '/$userId',
    path: '/$userId',
    getParentRoute: () => AuthenticatedManagementUsersRoute,
  } as any)
const PublicAuthenticationInvitationAuthenticationTokenIdRoute =
  PublicAuthenticationInvitationAuthenticationTokenIdRouteImport.update({
    id: '/_public/_authentication/invitation/$authenticationTokenId',
    path: '/invitation/$authenticationTokenId',
    getParentRoute: () => rootRouteImport,
  } as any)
const PublicAuthenticationPasswordResetIndexRoute =
  PublicAuthenticationPasswordResetIndexRouteImport.update({
    id: '/_public/_authentication/password-reset/',
    path: '/password-reset/',
    getParentRoute: () => rootRouteImport,
  } as any)
const PublicAuthenticationPasswordResetAuthenticationTokenIdRoute =
  PublicAuthenticationPasswordResetAuthenticationTokenIdRouteImport.update({
    id: '/_public/_authentication/password-reset/$authenticationTokenId',
    path: '/password-reset/$authenticationTokenId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthenticatedManagementOrganizationsOrganizationIdIndexRoute =
  AuthenticatedManagementOrganizationsOrganizationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedManagementOrganizationsOrganizationIdRoute,
  } as any)
const AuthenticatedManagementStationlessParkAndRideFacilityIdIndexRoute =
  AuthenticatedManagementStationlessParkAndRideFacilityIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedManagementStationlessParkAndRideFacilityIdRoute,
    } as any,
  )
const AuthenticatedManagementStationlessParkAndRideFacilityIdAuditsRoute =
  AuthenticatedManagementStationlessParkAndRideFacilityIdAuditsRouteImport.update(
    {
      id: '/audits',
      path: '/audits',
      getParentRoute: () =>
        AuthenticatedManagementStationlessParkAndRideFacilityIdRoute,
    } as any,
  )
const AuthenticatedManagementStationsStationIdIndexRoute =
  AuthenticatedManagementStationsStationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedManagementStationsStationIdRoute,
  } as any)
const AuthenticatedManagementStationsStationIdAuditsRoute =
  AuthenticatedManagementStationsStationIdAuditsRouteImport.update({
    id: '/audits',
    path: '/audits',
    getParentRoute: () => AuthenticatedManagementStationsStationIdRoute,
  } as any)
const AuthenticatedManagementUsersUserIdIndexRoute =
  AuthenticatedManagementUsersUserIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedManagementUsersUserIdRoute,
  } as any)
const PublicMapSidebarParkAndRideFacilitiesParkAndRideFacilityIdRoute =
  PublicMapSidebarParkAndRideFacilitiesParkAndRideFacilityIdRouteImport.update({
    id: '/park-and-ride-facilities/$parkAndRideFacilityId',
    path: '/park-and-ride-facilities/$parkAndRideFacilityId',
    getParentRoute: () => PublicMapSidebarRoute,
  } as any)
const PublicMapSidebarParkingFacilitiesParkingFacilityIdRoute =
  PublicMapSidebarParkingFacilitiesParkingFacilityIdRouteImport.update({
    id: '/parking-facilities/$parkingFacilityId',
    path: '/parking-facilities/$parkingFacilityId',
    getParentRoute: () => PublicMapSidebarRoute,
  } as any)
const PublicMapSidebarPickupParkingFacilitiesPickupParkingFacilityIdRoute =
  PublicMapSidebarPickupParkingFacilitiesPickupParkingFacilityIdRouteImport.update(
    {
      id: '/pickup-parking-facilities/$pickupParkingFacilityId',
      path: '/pickup-parking-facilities/$pickupParkingFacilityId',
      getParentRoute: () => PublicMapSidebarRoute,
    } as any,
  )
const PublicMapSidebarStationsStationIdRoute =
  PublicMapSidebarStationsStationIdRouteImport.update({
    id: '/stations/$stationId',
    path: '/stations/$stationId',
    getParentRoute: () => PublicMapSidebarRoute,
  } as any)
const AuthenticatedManagementOrganizationsOrganizationIdOrganizationUsersOrganizationUserIdRoute =
  AuthenticatedManagementOrganizationsOrganizationIdOrganizationUsersOrganizationUserIdRouteImport.update(
    {
      id: '/organizationUsers/$organizationUserId',
      path: '/organizationUsers/$organizationUserId',
      getParentRoute: () =>
        AuthenticatedManagementOrganizationsOrganizationIdRoute,
    } as any,
  )
const AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdRoute =
  AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdRouteImport.update(
    {
      id: '/park-and-ride-facilities/$parkAndRideFacilityId',
      path: '/park-and-ride-facilities/$parkAndRideFacilityId',
      getParentRoute: () => AuthenticatedManagementStationsStationIdRoute,
    } as any,
  )
const AuthenticatedManagementStationsStationIdParkAndRideFacilitiesCreateRoute =
  AuthenticatedManagementStationsStationIdParkAndRideFacilitiesCreateRouteImport.update(
    {
      id: '/park-and-ride-facilities/create',
      path: '/park-and-ride-facilities/create',
      getParentRoute: () => AuthenticatedManagementStationsStationIdRoute,
    } as any,
  )
const AuthenticatedManagementOrganizationsOrganizationIdOrganizationUsersOrganizationUserIdIndexRoute =
  AuthenticatedManagementOrganizationsOrganizationIdOrganizationUsersOrganizationUserIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedManagementOrganizationsOrganizationIdOrganizationUsersOrganizationUserIdRoute,
    } as any,
  )
const AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdIndexRoute =
  AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdRoute,
    } as any,
  )
const AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdAuditsRoute =
  AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdAuditsRouteImport.update(
    {
      id: '/audits',
      path: '/audits',
      getParentRoute: () =>
        AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof PublicMapIndexRoute
  '/management/organizations': typeof AuthenticatedManagementOrganizationsRouteWithChildren
  '/management/profile': typeof AuthenticatedManagementProfileRouteWithChildren
  '/management/stationless': typeof AuthenticatedManagementStationlessRouteWithChildren
  '/management/stations': typeof AuthenticatedManagementStationsRouteWithChildren
  '/management/users': typeof AuthenticatedManagementUsersRouteWithChildren
  '/login': typeof PublicAuthenticationLoginRoute
  '/about': typeof PublicLegalAboutLazyRoute
  '/accessibility': typeof PublicLegalAccessibilityLazyRoute
  '/contact': typeof PublicLegalContactLazyRoute
  '/frequently-asked-questions': typeof PublicLegalFrequentlyAskedQuestionsLazyRoute
  '/imprint': typeof PublicLegalImprintLazyRoute
  '/privacy': typeof PublicLegalPrivacyLazyRoute
  '/terms-of-use': typeof PublicLegalTermsOfUseLazyRoute
  '/management/': typeof AuthenticatedManagementIndexRoute
  '/management/organizations/$organizationId': typeof AuthenticatedManagementOrganizationsOrganizationIdRouteWithChildren
  '/management/organizations/create': typeof AuthenticatedManagementOrganizationsCreateRoute
  '/management/stationless/$parkAndRideFacilityId': typeof AuthenticatedManagementStationlessParkAndRideFacilityIdRouteWithChildren
  '/management/stationless/create': typeof AuthenticatedManagementStationlessCreateRoute
  '/management/stations/$stationId': typeof AuthenticatedManagementStationsStationIdRouteWithChildren
  '/management/stations/create': typeof AuthenticatedManagementStationsCreateRoute
  '/management/users/$userId': typeof AuthenticatedManagementUsersUserIdRouteWithChildren
  '/invitation/$authenticationTokenId': typeof PublicAuthenticationInvitationAuthenticationTokenIdRoute
  '/password-reset/$authenticationTokenId': typeof PublicAuthenticationPasswordResetAuthenticationTokenIdRoute
  '/management/organizations/': typeof AuthenticatedManagementOrganizationsIndexRoute
  '/management/profile/': typeof AuthenticatedManagementProfileIndexRoute
  '/management/stationless/': typeof AuthenticatedManagementStationlessIndexRoute
  '/management/stations/': typeof AuthenticatedManagementStationsIndexRoute
  '/management/users/': typeof AuthenticatedManagementUsersIndexRoute
  '/password-reset/': typeof PublicAuthenticationPasswordResetIndexRoute
  '/management/stationless/$parkAndRideFacilityId/audits': typeof AuthenticatedManagementStationlessParkAndRideFacilityIdAuditsRoute
  '/management/stations/$stationId/audits': typeof AuthenticatedManagementStationsStationIdAuditsRoute
  '/park-and-ride-facilities/$parkAndRideFacilityId': typeof PublicMapSidebarParkAndRideFacilitiesParkAndRideFacilityIdRoute
  '/parking-facilities/$parkingFacilityId': typeof PublicMapSidebarParkingFacilitiesParkingFacilityIdRoute
  '/pickup-parking-facilities/$pickupParkingFacilityId': typeof PublicMapSidebarPickupParkingFacilitiesPickupParkingFacilityIdRoute
  '/stations/$stationId': typeof PublicMapSidebarStationsStationIdRoute
  '/management/organizations/$organizationId/': typeof AuthenticatedManagementOrganizationsOrganizationIdIndexRoute
  '/management/stationless/$parkAndRideFacilityId/': typeof AuthenticatedManagementStationlessParkAndRideFacilityIdIndexRoute
  '/management/stations/$stationId/': typeof AuthenticatedManagementStationsStationIdIndexRoute
  '/management/users/$userId/': typeof AuthenticatedManagementUsersUserIdIndexRoute
  '/management/organizations/$organizationId/organizationUsers/$organizationUserId': typeof AuthenticatedManagementOrganizationsOrganizationIdOrganizationUsersOrganizationUserIdRouteWithChildren
  '/management/stations/$stationId/park-and-ride-facilities/$parkAndRideFacilityId': typeof AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdRouteWithChildren
  '/management/stations/$stationId/park-and-ride-facilities/create': typeof AuthenticatedManagementStationsStationIdParkAndRideFacilitiesCreateRoute
  '/management/stations/$stationId/park-and-ride-facilities/$parkAndRideFacilityId/audits': typeof AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdAuditsRoute
  '/management/organizations/$organizationId/organizationUsers/$organizationUserId/': typeof AuthenticatedManagementOrganizationsOrganizationIdOrganizationUsersOrganizationUserIdIndexRoute
  '/management/stations/$stationId/park-and-ride-facilities/$parkAndRideFacilityId/': typeof AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof PublicMapIndexRoute
  '/login': typeof PublicAuthenticationLoginRoute
  '/about': typeof PublicLegalAboutLazyRoute
  '/accessibility': typeof PublicLegalAccessibilityLazyRoute
  '/contact': typeof PublicLegalContactLazyRoute
  '/frequently-asked-questions': typeof PublicLegalFrequentlyAskedQuestionsLazyRoute
  '/imprint': typeof PublicLegalImprintLazyRoute
  '/privacy': typeof PublicLegalPrivacyLazyRoute
  '/terms-of-use': typeof PublicLegalTermsOfUseLazyRoute
  '/management': typeof AuthenticatedManagementIndexRoute
  '/management/organizations/create': typeof AuthenticatedManagementOrganizationsCreateRoute
  '/management/stationless/create': typeof AuthenticatedManagementStationlessCreateRoute
  '/management/stations/create': typeof AuthenticatedManagementStationsCreateRoute
  '/invitation/$authenticationTokenId': typeof PublicAuthenticationInvitationAuthenticationTokenIdRoute
  '/password-reset/$authenticationTokenId': typeof PublicAuthenticationPasswordResetAuthenticationTokenIdRoute
  '/management/organizations': typeof AuthenticatedManagementOrganizationsIndexRoute
  '/management/profile': typeof AuthenticatedManagementProfileIndexRoute
  '/management/stationless': typeof AuthenticatedManagementStationlessIndexRoute
  '/management/stations': typeof AuthenticatedManagementStationsIndexRoute
  '/management/users': typeof AuthenticatedManagementUsersIndexRoute
  '/password-reset': typeof PublicAuthenticationPasswordResetIndexRoute
  '/management/stationless/$parkAndRideFacilityId/audits': typeof AuthenticatedManagementStationlessParkAndRideFacilityIdAuditsRoute
  '/management/stations/$stationId/audits': typeof AuthenticatedManagementStationsStationIdAuditsRoute
  '/park-and-ride-facilities/$parkAndRideFacilityId': typeof PublicMapSidebarParkAndRideFacilitiesParkAndRideFacilityIdRoute
  '/parking-facilities/$parkingFacilityId': typeof PublicMapSidebarParkingFacilitiesParkingFacilityIdRoute
  '/pickup-parking-facilities/$pickupParkingFacilityId': typeof PublicMapSidebarPickupParkingFacilitiesPickupParkingFacilityIdRoute
  '/stations/$stationId': typeof PublicMapSidebarStationsStationIdRoute
  '/management/organizations/$organizationId': typeof AuthenticatedManagementOrganizationsOrganizationIdIndexRoute
  '/management/stationless/$parkAndRideFacilityId': typeof AuthenticatedManagementStationlessParkAndRideFacilityIdIndexRoute
  '/management/stations/$stationId': typeof AuthenticatedManagementStationsStationIdIndexRoute
  '/management/users/$userId': typeof AuthenticatedManagementUsersUserIdIndexRoute
  '/management/stations/$stationId/park-and-ride-facilities/create': typeof AuthenticatedManagementStationsStationIdParkAndRideFacilitiesCreateRoute
  '/management/stations/$stationId/park-and-ride-facilities/$parkAndRideFacilityId/audits': typeof AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdAuditsRoute
  '/management/organizations/$organizationId/organizationUsers/$organizationUserId': typeof AuthenticatedManagementOrganizationsOrganizationIdOrganizationUsersOrganizationUserIdIndexRoute
  '/management/stations/$stationId/park-and-ride-facilities/$parkAndRideFacilityId': typeof AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_public/_legal': typeof PublicLegalRouteWithChildren
  '/_public/_map': typeof PublicMapRouteWithChildren
  '/_authenticated/management/organizations': typeof AuthenticatedManagementOrganizationsRouteWithChildren
  '/_authenticated/management/profile': typeof AuthenticatedManagementProfileRouteWithChildren
  '/_authenticated/management/stationless': typeof AuthenticatedManagementStationlessRouteWithChildren
  '/_authenticated/management/stations': typeof AuthenticatedManagementStationsRouteWithChildren
  '/_authenticated/management/users': typeof AuthenticatedManagementUsersRouteWithChildren
  '/_public/_authentication/login': typeof PublicAuthenticationLoginRoute
  '/_public/_map/_sidebar': typeof PublicMapSidebarRouteWithChildren
  '/_public/_legal/about': typeof PublicLegalAboutLazyRoute
  '/_public/_legal/accessibility': typeof PublicLegalAccessibilityLazyRoute
  '/_public/_legal/contact': typeof PublicLegalContactLazyRoute
  '/_public/_legal/frequently-asked-questions': typeof PublicLegalFrequentlyAskedQuestionsLazyRoute
  '/_public/_legal/imprint': typeof PublicLegalImprintLazyRoute
  '/_public/_legal/privacy': typeof PublicLegalPrivacyLazyRoute
  '/_public/_legal/terms-of-use': typeof PublicLegalTermsOfUseLazyRoute
  '/_authenticated/management/': typeof AuthenticatedManagementIndexRoute
  '/_public/_map/': typeof PublicMapIndexRoute
  '/_authenticated/management/organizations/$organizationId': typeof AuthenticatedManagementOrganizationsOrganizationIdRouteWithChildren
  '/_authenticated/management/organizations/create': typeof AuthenticatedManagementOrganizationsCreateRoute
  '/_authenticated/management/stationless/$parkAndRideFacilityId': typeof AuthenticatedManagementStationlessParkAndRideFacilityIdRouteWithChildren
  '/_authenticated/management/stationless/create': typeof AuthenticatedManagementStationlessCreateRoute
  '/_authenticated/management/stations/$stationId': typeof AuthenticatedManagementStationsStationIdRouteWithChildren
  '/_authenticated/management/stations/create': typeof AuthenticatedManagementStationsCreateRoute
  '/_authenticated/management/users/$userId': typeof AuthenticatedManagementUsersUserIdRouteWithChildren
  '/_public/_authentication/invitation/$authenticationTokenId': typeof PublicAuthenticationInvitationAuthenticationTokenIdRoute
  '/_public/_authentication/password-reset/$authenticationTokenId': typeof PublicAuthenticationPasswordResetAuthenticationTokenIdRoute
  '/_authenticated/management/organizations/': typeof AuthenticatedManagementOrganizationsIndexRoute
  '/_authenticated/management/profile/': typeof AuthenticatedManagementProfileIndexRoute
  '/_authenticated/management/stationless/': typeof AuthenticatedManagementStationlessIndexRoute
  '/_authenticated/management/stations/': typeof AuthenticatedManagementStationsIndexRoute
  '/_authenticated/management/users/': typeof AuthenticatedManagementUsersIndexRoute
  '/_public/_authentication/password-reset/': typeof PublicAuthenticationPasswordResetIndexRoute
  '/_authenticated/management/stationless/$parkAndRideFacilityId/audits': typeof AuthenticatedManagementStationlessParkAndRideFacilityIdAuditsRoute
  '/_authenticated/management/stations/$stationId/audits': typeof AuthenticatedManagementStationsStationIdAuditsRoute
  '/_public/_map/_sidebar/park-and-ride-facilities/$parkAndRideFacilityId': typeof PublicMapSidebarParkAndRideFacilitiesParkAndRideFacilityIdRoute
  '/_public/_map/_sidebar/parking-facilities/$parkingFacilityId': typeof PublicMapSidebarParkingFacilitiesParkingFacilityIdRoute
  '/_public/_map/_sidebar/pickup-parking-facilities/$pickupParkingFacilityId': typeof PublicMapSidebarPickupParkingFacilitiesPickupParkingFacilityIdRoute
  '/_public/_map/_sidebar/stations/$stationId': typeof PublicMapSidebarStationsStationIdRoute
  '/_authenticated/management/organizations/$organizationId/': typeof AuthenticatedManagementOrganizationsOrganizationIdIndexRoute
  '/_authenticated/management/stationless/$parkAndRideFacilityId/': typeof AuthenticatedManagementStationlessParkAndRideFacilityIdIndexRoute
  '/_authenticated/management/stations/$stationId/': typeof AuthenticatedManagementStationsStationIdIndexRoute
  '/_authenticated/management/users/$userId/': typeof AuthenticatedManagementUsersUserIdIndexRoute
  '/_authenticated/management/organizations/$organizationId/organizationUsers/$organizationUserId': typeof AuthenticatedManagementOrganizationsOrganizationIdOrganizationUsersOrganizationUserIdRouteWithChildren
  '/_authenticated/management/stations/$stationId/park-and-ride-facilities/$parkAndRideFacilityId': typeof AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdRouteWithChildren
  '/_authenticated/management/stations/$stationId/park-and-ride-facilities/create': typeof AuthenticatedManagementStationsStationIdParkAndRideFacilitiesCreateRoute
  '/_authenticated/management/stations/$stationId/park-and-ride-facilities/$parkAndRideFacilityId/audits': typeof AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdAuditsRoute
  '/_authenticated/management/organizations/$organizationId/organizationUsers/$organizationUserId/': typeof AuthenticatedManagementOrganizationsOrganizationIdOrganizationUsersOrganizationUserIdIndexRoute
  '/_authenticated/management/stations/$stationId/park-and-ride-facilities/$parkAndRideFacilityId/': typeof AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/management/organizations'
    | '/management/profile'
    | '/management/stationless'
    | '/management/stations'
    | '/management/users'
    | '/login'
    | '/about'
    | '/accessibility'
    | '/contact'
    | '/frequently-asked-questions'
    | '/imprint'
    | '/privacy'
    | '/terms-of-use'
    | '/management/'
    | '/management/organizations/$organizationId'
    | '/management/organizations/create'
    | '/management/stationless/$parkAndRideFacilityId'
    | '/management/stationless/create'
    | '/management/stations/$stationId'
    | '/management/stations/create'
    | '/management/users/$userId'
    | '/invitation/$authenticationTokenId'
    | '/password-reset/$authenticationTokenId'
    | '/management/organizations/'
    | '/management/profile/'
    | '/management/stationless/'
    | '/management/stations/'
    | '/management/users/'
    | '/password-reset/'
    | '/management/stationless/$parkAndRideFacilityId/audits'
    | '/management/stations/$stationId/audits'
    | '/park-and-ride-facilities/$parkAndRideFacilityId'
    | '/parking-facilities/$parkingFacilityId'
    | '/pickup-parking-facilities/$pickupParkingFacilityId'
    | '/stations/$stationId'
    | '/management/organizations/$organizationId/'
    | '/management/stationless/$parkAndRideFacilityId/'
    | '/management/stations/$stationId/'
    | '/management/users/$userId/'
    | '/management/organizations/$organizationId/organizationUsers/$organizationUserId'
    | '/management/stations/$stationId/park-and-ride-facilities/$parkAndRideFacilityId'
    | '/management/stations/$stationId/park-and-ride-facilities/create'
    | '/management/stations/$stationId/park-and-ride-facilities/$parkAndRideFacilityId/audits'
    | '/management/organizations/$organizationId/organizationUsers/$organizationUserId/'
    | '/management/stations/$stationId/park-and-ride-facilities/$parkAndRideFacilityId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/about'
    | '/accessibility'
    | '/contact'
    | '/frequently-asked-questions'
    | '/imprint'
    | '/privacy'
    | '/terms-of-use'
    | '/management'
    | '/management/organizations/create'
    | '/management/stationless/create'
    | '/management/stations/create'
    | '/invitation/$authenticationTokenId'
    | '/password-reset/$authenticationTokenId'
    | '/management/organizations'
    | '/management/profile'
    | '/management/stationless'
    | '/management/stations'
    | '/management/users'
    | '/password-reset'
    | '/management/stationless/$parkAndRideFacilityId/audits'
    | '/management/stations/$stationId/audits'
    | '/park-and-ride-facilities/$parkAndRideFacilityId'
    | '/parking-facilities/$parkingFacilityId'
    | '/pickup-parking-facilities/$pickupParkingFacilityId'
    | '/stations/$stationId'
    | '/management/organizations/$organizationId'
    | '/management/stationless/$parkAndRideFacilityId'
    | '/management/stations/$stationId'
    | '/management/users/$userId'
    | '/management/stations/$stationId/park-and-ride-facilities/create'
    | '/management/stations/$stationId/park-and-ride-facilities/$parkAndRideFacilityId/audits'
    | '/management/organizations/$organizationId/organizationUsers/$organizationUserId'
    | '/management/stations/$stationId/park-and-ride-facilities/$parkAndRideFacilityId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_public/_legal'
    | '/_public/_map'
    | '/_authenticated/management/organizations'
    | '/_authenticated/management/profile'
    | '/_authenticated/management/stationless'
    | '/_authenticated/management/stations'
    | '/_authenticated/management/users'
    | '/_public/_authentication/login'
    | '/_public/_map/_sidebar'
    | '/_public/_legal/about'
    | '/_public/_legal/accessibility'
    | '/_public/_legal/contact'
    | '/_public/_legal/frequently-asked-questions'
    | '/_public/_legal/imprint'
    | '/_public/_legal/privacy'
    | '/_public/_legal/terms-of-use'
    | '/_authenticated/management/'
    | '/_public/_map/'
    | '/_authenticated/management/organizations/$organizationId'
    | '/_authenticated/management/organizations/create'
    | '/_authenticated/management/stationless/$parkAndRideFacilityId'
    | '/_authenticated/management/stationless/create'
    | '/_authenticated/management/stations/$stationId'
    | '/_authenticated/management/stations/create'
    | '/_authenticated/management/users/$userId'
    | '/_public/_authentication/invitation/$authenticationTokenId'
    | '/_public/_authentication/password-reset/$authenticationTokenId'
    | '/_authenticated/management/organizations/'
    | '/_authenticated/management/profile/'
    | '/_authenticated/management/stationless/'
    | '/_authenticated/management/stations/'
    | '/_authenticated/management/users/'
    | '/_public/_authentication/password-reset/'
    | '/_authenticated/management/stationless/$parkAndRideFacilityId/audits'
    | '/_authenticated/management/stations/$stationId/audits'
    | '/_public/_map/_sidebar/park-and-ride-facilities/$parkAndRideFacilityId'
    | '/_public/_map/_sidebar/parking-facilities/$parkingFacilityId'
    | '/_public/_map/_sidebar/pickup-parking-facilities/$pickupParkingFacilityId'
    | '/_public/_map/_sidebar/stations/$stationId'
    | '/_authenticated/management/organizations/$organizationId/'
    | '/_authenticated/management/stationless/$parkAndRideFacilityId/'
    | '/_authenticated/management/stations/$stationId/'
    | '/_authenticated/management/users/$userId/'
    | '/_authenticated/management/organizations/$organizationId/organizationUsers/$organizationUserId'
    | '/_authenticated/management/stations/$stationId/park-and-ride-facilities/$parkAndRideFacilityId'
    | '/_authenticated/management/stations/$stationId/park-and-ride-facilities/create'
    | '/_authenticated/management/stations/$stationId/park-and-ride-facilities/$parkAndRideFacilityId/audits'
    | '/_authenticated/management/organizations/$organizationId/organizationUsers/$organizationUserId/'
    | '/_authenticated/management/stations/$stationId/park-and-ride-facilities/$parkAndRideFacilityId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  PublicLegalRoute: typeof PublicLegalRouteWithChildren
  PublicMapRoute: typeof PublicMapRouteWithChildren
  PublicAuthenticationLoginRoute: typeof PublicAuthenticationLoginRoute
  PublicAuthenticationInvitationAuthenticationTokenIdRoute: typeof PublicAuthenticationInvitationAuthenticationTokenIdRoute
  PublicAuthenticationPasswordResetAuthenticationTokenIdRoute: typeof PublicAuthenticationPasswordResetAuthenticationTokenIdRoute
  PublicAuthenticationPasswordResetIndexRoute: typeof PublicAuthenticationPasswordResetIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/_legal': {
      id: '/_public/_legal'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicLegalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/_map': {
      id: '/_public/_map'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicMapRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/management/': {
      id: '/_authenticated/management/'
      path: '/management'
      fullPath: '/management/'
      preLoaderRoute: typeof AuthenticatedManagementIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/management/organizations': {
      id: '/_authenticated/management/organizations'
      path: '/management/organizations'
      fullPath: '/management/organizations'
      preLoaderRoute: typeof AuthenticatedManagementOrganizationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/management/profile': {
      id: '/_authenticated/management/profile'
      path: '/management/profile'
      fullPath: '/management/profile'
      preLoaderRoute: typeof AuthenticatedManagementProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/management/stationless': {
      id: '/_authenticated/management/stationless'
      path: '/management/stationless'
      fullPath: '/management/stationless'
      preLoaderRoute: typeof AuthenticatedManagementStationlessRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/management/stations': {
      id: '/_authenticated/management/stations'
      path: '/management/stations'
      fullPath: '/management/stations'
      preLoaderRoute: typeof AuthenticatedManagementStationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/management/users': {
      id: '/_authenticated/management/users'
      path: '/management/users'
      fullPath: '/management/users'
      preLoaderRoute: typeof AuthenticatedManagementUsersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_public/_authentication/login': {
      id: '/_public/_authentication/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicAuthenticationLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/_legal/about': {
      id: '/_public/_legal/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof PublicLegalAboutLazyRouteImport
      parentRoute: typeof PublicLegalRoute
    }
    '/_public/_legal/accessibility': {
      id: '/_public/_legal/accessibility'
      path: '/accessibility'
      fullPath: '/accessibility'
      preLoaderRoute: typeof PublicLegalAccessibilityLazyRouteImport
      parentRoute: typeof PublicLegalRoute
    }
    '/_public/_legal/contact': {
      id: '/_public/_legal/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof PublicLegalContactLazyRouteImport
      parentRoute: typeof PublicLegalRoute
    }
    '/_public/_legal/frequently-asked-questions': {
      id: '/_public/_legal/frequently-asked-questions'
      path: '/frequently-asked-questions'
      fullPath: '/frequently-asked-questions'
      preLoaderRoute: typeof PublicLegalFrequentlyAskedQuestionsLazyRouteImport
      parentRoute: typeof PublicLegalRoute
    }
    '/_public/_legal/imprint': {
      id: '/_public/_legal/imprint'
      path: '/imprint'
      fullPath: '/imprint'
      preLoaderRoute: typeof PublicLegalImprintLazyRouteImport
      parentRoute: typeof PublicLegalRoute
    }
    '/_public/_legal/privacy': {
      id: '/_public/_legal/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PublicLegalPrivacyLazyRouteImport
      parentRoute: typeof PublicLegalRoute
    }
    '/_public/_legal/terms-of-use': {
      id: '/_public/_legal/terms-of-use'
      path: '/terms-of-use'
      fullPath: '/terms-of-use'
      preLoaderRoute: typeof PublicLegalTermsOfUseLazyRouteImport
      parentRoute: typeof PublicLegalRoute
    }
    '/_public/_map/': {
      id: '/_public/_map/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PublicMapIndexRouteImport
      parentRoute: typeof PublicMapRoute
    }
    '/_public/_map/_sidebar': {
      id: '/_public/_map/_sidebar'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicMapSidebarRouteImport
      parentRoute: typeof PublicMapRoute
    }
    '/_authenticated/management/organizations/': {
      id: '/_authenticated/management/organizations/'
      path: '/'
      fullPath: '/management/organizations/'
      preLoaderRoute: typeof AuthenticatedManagementOrganizationsIndexRouteImport
      parentRoute: typeof AuthenticatedManagementOrganizationsRoute
    }
    '/_authenticated/management/organizations/$organizationId': {
      id: '/_authenticated/management/organizations/$organizationId'
      path: '/$organizationId'
      fullPath: '/management/organizations/$organizationId'
      preLoaderRoute: typeof AuthenticatedManagementOrganizationsOrganizationIdRouteImport
      parentRoute: typeof AuthenticatedManagementOrganizationsRoute
    }
    '/_authenticated/management/organizations/create': {
      id: '/_authenticated/management/organizations/create'
      path: '/create'
      fullPath: '/management/organizations/create'
      preLoaderRoute: typeof AuthenticatedManagementOrganizationsCreateRouteImport
      parentRoute: typeof AuthenticatedManagementOrganizationsRoute
    }
    '/_authenticated/management/profile/': {
      id: '/_authenticated/management/profile/'
      path: '/'
      fullPath: '/management/profile/'
      preLoaderRoute: typeof AuthenticatedManagementProfileIndexRouteImport
      parentRoute: typeof AuthenticatedManagementProfileRoute
    }
    '/_authenticated/management/stationless/': {
      id: '/_authenticated/management/stationless/'
      path: '/'
      fullPath: '/management/stationless/'
      preLoaderRoute: typeof AuthenticatedManagementStationlessIndexRouteImport
      parentRoute: typeof AuthenticatedManagementStationlessRoute
    }
    '/_authenticated/management/stationless/$parkAndRideFacilityId': {
      id: '/_authenticated/management/stationless/$parkAndRideFacilityId'
      path: '/$parkAndRideFacilityId'
      fullPath: '/management/stationless/$parkAndRideFacilityId'
      preLoaderRoute: typeof AuthenticatedManagementStationlessParkAndRideFacilityIdRouteImport
      parentRoute: typeof AuthenticatedManagementStationlessRoute
    }
    '/_authenticated/management/stationless/create': {
      id: '/_authenticated/management/stationless/create'
      path: '/create'
      fullPath: '/management/stationless/create'
      preLoaderRoute: typeof AuthenticatedManagementStationlessCreateRouteImport
      parentRoute: typeof AuthenticatedManagementStationlessRoute
    }
    '/_authenticated/management/stations/': {
      id: '/_authenticated/management/stations/'
      path: '/'
      fullPath: '/management/stations/'
      preLoaderRoute: typeof AuthenticatedManagementStationsIndexRouteImport
      parentRoute: typeof AuthenticatedManagementStationsRoute
    }
    '/_authenticated/management/stations/$stationId': {
      id: '/_authenticated/management/stations/$stationId'
      path: '/$stationId'
      fullPath: '/management/stations/$stationId'
      preLoaderRoute: typeof AuthenticatedManagementStationsStationIdRouteImport
      parentRoute: typeof AuthenticatedManagementStationsRoute
    }
    '/_authenticated/management/stations/create': {
      id: '/_authenticated/management/stations/create'
      path: '/create'
      fullPath: '/management/stations/create'
      preLoaderRoute: typeof AuthenticatedManagementStationsCreateRouteImport
      parentRoute: typeof AuthenticatedManagementStationsRoute
    }
    '/_authenticated/management/users/': {
      id: '/_authenticated/management/users/'
      path: '/'
      fullPath: '/management/users/'
      preLoaderRoute: typeof AuthenticatedManagementUsersIndexRouteImport
      parentRoute: typeof AuthenticatedManagementUsersRoute
    }
    '/_authenticated/management/users/$userId': {
      id: '/_authenticated/management/users/$userId'
      path: '/$userId'
      fullPath: '/management/users/$userId'
      preLoaderRoute: typeof AuthenticatedManagementUsersUserIdRouteImport
      parentRoute: typeof AuthenticatedManagementUsersRoute
    }
    '/_public/_authentication/invitation/$authenticationTokenId': {
      id: '/_public/_authentication/invitation/$authenticationTokenId'
      path: '/invitation/$authenticationTokenId'
      fullPath: '/invitation/$authenticationTokenId'
      preLoaderRoute: typeof PublicAuthenticationInvitationAuthenticationTokenIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/_authentication/password-reset/': {
      id: '/_public/_authentication/password-reset/'
      path: '/password-reset'
      fullPath: '/password-reset/'
      preLoaderRoute: typeof PublicAuthenticationPasswordResetIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/_authentication/password-reset/$authenticationTokenId': {
      id: '/_public/_authentication/password-reset/$authenticationTokenId'
      path: '/password-reset/$authenticationTokenId'
      fullPath: '/password-reset/$authenticationTokenId'
      preLoaderRoute: typeof PublicAuthenticationPasswordResetAuthenticationTokenIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/management/organizations/$organizationId/': {
      id: '/_authenticated/management/organizations/$organizationId/'
      path: '/'
      fullPath: '/management/organizations/$organizationId/'
      preLoaderRoute: typeof AuthenticatedManagementOrganizationsOrganizationIdIndexRouteImport
      parentRoute: typeof AuthenticatedManagementOrganizationsOrganizationIdRoute
    }
    '/_authenticated/management/stationless/$parkAndRideFacilityId/': {
      id: '/_authenticated/management/stationless/$parkAndRideFacilityId/'
      path: '/'
      fullPath: '/management/stationless/$parkAndRideFacilityId/'
      preLoaderRoute: typeof AuthenticatedManagementStationlessParkAndRideFacilityIdIndexRouteImport
      parentRoute: typeof AuthenticatedManagementStationlessParkAndRideFacilityIdRoute
    }
    '/_authenticated/management/stationless/$parkAndRideFacilityId/audits': {
      id: '/_authenticated/management/stationless/$parkAndRideFacilityId/audits'
      path: '/audits'
      fullPath: '/management/stationless/$parkAndRideFacilityId/audits'
      preLoaderRoute: typeof AuthenticatedManagementStationlessParkAndRideFacilityIdAuditsRouteImport
      parentRoute: typeof AuthenticatedManagementStationlessParkAndRideFacilityIdRoute
    }
    '/_authenticated/management/stations/$stationId/': {
      id: '/_authenticated/management/stations/$stationId/'
      path: '/'
      fullPath: '/management/stations/$stationId/'
      preLoaderRoute: typeof AuthenticatedManagementStationsStationIdIndexRouteImport
      parentRoute: typeof AuthenticatedManagementStationsStationIdRoute
    }
    '/_authenticated/management/stations/$stationId/audits': {
      id: '/_authenticated/management/stations/$stationId/audits'
      path: '/audits'
      fullPath: '/management/stations/$stationId/audits'
      preLoaderRoute: typeof AuthenticatedManagementStationsStationIdAuditsRouteImport
      parentRoute: typeof AuthenticatedManagementStationsStationIdRoute
    }
    '/_authenticated/management/users/$userId/': {
      id: '/_authenticated/management/users/$userId/'
      path: '/'
      fullPath: '/management/users/$userId/'
      preLoaderRoute: typeof AuthenticatedManagementUsersUserIdIndexRouteImport
      parentRoute: typeof AuthenticatedManagementUsersUserIdRoute
    }
    '/_public/_map/_sidebar/park-and-ride-facilities/$parkAndRideFacilityId': {
      id: '/_public/_map/_sidebar/park-and-ride-facilities/$parkAndRideFacilityId'
      path: '/park-and-ride-facilities/$parkAndRideFacilityId'
      fullPath: '/park-and-ride-facilities/$parkAndRideFacilityId'
      preLoaderRoute: typeof PublicMapSidebarParkAndRideFacilitiesParkAndRideFacilityIdRouteImport
      parentRoute: typeof PublicMapSidebarRoute
    }
    '/_public/_map/_sidebar/parking-facilities/$parkingFacilityId': {
      id: '/_public/_map/_sidebar/parking-facilities/$parkingFacilityId'
      path: '/parking-facilities/$parkingFacilityId'
      fullPath: '/parking-facilities/$parkingFacilityId'
      preLoaderRoute: typeof PublicMapSidebarParkingFacilitiesParkingFacilityIdRouteImport
      parentRoute: typeof PublicMapSidebarRoute
    }
    '/_public/_map/_sidebar/pickup-parking-facilities/$pickupParkingFacilityId': {
      id: '/_public/_map/_sidebar/pickup-parking-facilities/$pickupParkingFacilityId'
      path: '/pickup-parking-facilities/$pickupParkingFacilityId'
      fullPath: '/pickup-parking-facilities/$pickupParkingFacilityId'
      preLoaderRoute: typeof PublicMapSidebarPickupParkingFacilitiesPickupParkingFacilityIdRouteImport
      parentRoute: typeof PublicMapSidebarRoute
    }
    '/_public/_map/_sidebar/stations/$stationId': {
      id: '/_public/_map/_sidebar/stations/$stationId'
      path: '/stations/$stationId'
      fullPath: '/stations/$stationId'
      preLoaderRoute: typeof PublicMapSidebarStationsStationIdRouteImport
      parentRoute: typeof PublicMapSidebarRoute
    }
    '/_authenticated/management/organizations/$organizationId/organizationUsers/$organizationUserId': {
      id: '/_authenticated/management/organizations/$organizationId/organizationUsers/$organizationUserId'
      path: '/organizationUsers/$organizationUserId'
      fullPath: '/management/organizations/$organizationId/organizationUsers/$organizationUserId'
      preLoaderRoute: typeof AuthenticatedManagementOrganizationsOrganizationIdOrganizationUsersOrganizationUserIdRouteImport
      parentRoute: typeof AuthenticatedManagementOrganizationsOrganizationIdRoute
    }
    '/_authenticated/management/stations/$stationId/park-and-ride-facilities/$parkAndRideFacilityId': {
      id: '/_authenticated/management/stations/$stationId/park-and-ride-facilities/$parkAndRideFacilityId'
      path: '/park-and-ride-facilities/$parkAndRideFacilityId'
      fullPath: '/management/stations/$stationId/park-and-ride-facilities/$parkAndRideFacilityId'
      preLoaderRoute: typeof AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdRouteImport
      parentRoute: typeof AuthenticatedManagementStationsStationIdRoute
    }
    '/_authenticated/management/stations/$stationId/park-and-ride-facilities/create': {
      id: '/_authenticated/management/stations/$stationId/park-and-ride-facilities/create'
      path: '/park-and-ride-facilities/create'
      fullPath: '/management/stations/$stationId/park-and-ride-facilities/create'
      preLoaderRoute: typeof AuthenticatedManagementStationsStationIdParkAndRideFacilitiesCreateRouteImport
      parentRoute: typeof AuthenticatedManagementStationsStationIdRoute
    }
    '/_authenticated/management/organizations/$organizationId/organizationUsers/$organizationUserId/': {
      id: '/_authenticated/management/organizations/$organizationId/organizationUsers/$organizationUserId/'
      path: '/'
      fullPath: '/management/organizations/$organizationId/organizationUsers/$organizationUserId/'
      preLoaderRoute: typeof AuthenticatedManagementOrganizationsOrganizationIdOrganizationUsersOrganizationUserIdIndexRouteImport
      parentRoute: typeof AuthenticatedManagementOrganizationsOrganizationIdOrganizationUsersOrganizationUserIdRoute
    }
    '/_authenticated/management/stations/$stationId/park-and-ride-facilities/$parkAndRideFacilityId/': {
      id: '/_authenticated/management/stations/$stationId/park-and-ride-facilities/$parkAndRideFacilityId/'
      path: '/'
      fullPath: '/management/stations/$stationId/park-and-ride-facilities/$parkAndRideFacilityId/'
      preLoaderRoute: typeof AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdIndexRouteImport
      parentRoute: typeof AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdRoute
    }
    '/_authenticated/management/stations/$stationId/park-and-ride-facilities/$parkAndRideFacilityId/audits': {
      id: '/_authenticated/management/stations/$stationId/park-and-ride-facilities/$parkAndRideFacilityId/audits'
      path: '/audits'
      fullPath: '/management/stations/$stationId/park-and-ride-facilities/$parkAndRideFacilityId/audits'
      preLoaderRoute: typeof AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdAuditsRouteImport
      parentRoute: typeof AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdRoute
    }
  }
}

interface AuthenticatedManagementOrganizationsOrganizationIdOrganizationUsersOrganizationUserIdRouteChildren {
  AuthenticatedManagementOrganizationsOrganizationIdOrganizationUsersOrganizationUserIdIndexRoute: typeof AuthenticatedManagementOrganizationsOrganizationIdOrganizationUsersOrganizationUserIdIndexRoute
}

const AuthenticatedManagementOrganizationsOrganizationIdOrganizationUsersOrganizationUserIdRouteChildren: AuthenticatedManagementOrganizationsOrganizationIdOrganizationUsersOrganizationUserIdRouteChildren =
  {
    AuthenticatedManagementOrganizationsOrganizationIdOrganizationUsersOrganizationUserIdIndexRoute:
      AuthenticatedManagementOrganizationsOrganizationIdOrganizationUsersOrganizationUserIdIndexRoute,
  }

const AuthenticatedManagementOrganizationsOrganizationIdOrganizationUsersOrganizationUserIdRouteWithChildren =
  AuthenticatedManagementOrganizationsOrganizationIdOrganizationUsersOrganizationUserIdRoute._addFileChildren(
    AuthenticatedManagementOrganizationsOrganizationIdOrganizationUsersOrganizationUserIdRouteChildren,
  )

interface AuthenticatedManagementOrganizationsOrganizationIdRouteChildren {
  AuthenticatedManagementOrganizationsOrganizationIdIndexRoute: typeof AuthenticatedManagementOrganizationsOrganizationIdIndexRoute
  AuthenticatedManagementOrganizationsOrganizationIdOrganizationUsersOrganizationUserIdRoute: typeof AuthenticatedManagementOrganizationsOrganizationIdOrganizationUsersOrganizationUserIdRouteWithChildren
}

const AuthenticatedManagementOrganizationsOrganizationIdRouteChildren: AuthenticatedManagementOrganizationsOrganizationIdRouteChildren =
  {
    AuthenticatedManagementOrganizationsOrganizationIdIndexRoute:
      AuthenticatedManagementOrganizationsOrganizationIdIndexRoute,
    AuthenticatedManagementOrganizationsOrganizationIdOrganizationUsersOrganizationUserIdRoute:
      AuthenticatedManagementOrganizationsOrganizationIdOrganizationUsersOrganizationUserIdRouteWithChildren,
  }

const AuthenticatedManagementOrganizationsOrganizationIdRouteWithChildren =
  AuthenticatedManagementOrganizationsOrganizationIdRoute._addFileChildren(
    AuthenticatedManagementOrganizationsOrganizationIdRouteChildren,
  )

interface AuthenticatedManagementOrganizationsRouteChildren {
  AuthenticatedManagementOrganizationsOrganizationIdRoute: typeof AuthenticatedManagementOrganizationsOrganizationIdRouteWithChildren
  AuthenticatedManagementOrganizationsCreateRoute: typeof AuthenticatedManagementOrganizationsCreateRoute
  AuthenticatedManagementOrganizationsIndexRoute: typeof AuthenticatedManagementOrganizationsIndexRoute
}

const AuthenticatedManagementOrganizationsRouteChildren: AuthenticatedManagementOrganizationsRouteChildren =
  {
    AuthenticatedManagementOrganizationsOrganizationIdRoute:
      AuthenticatedManagementOrganizationsOrganizationIdRouteWithChildren,
    AuthenticatedManagementOrganizationsCreateRoute:
      AuthenticatedManagementOrganizationsCreateRoute,
    AuthenticatedManagementOrganizationsIndexRoute:
      AuthenticatedManagementOrganizationsIndexRoute,
  }

const AuthenticatedManagementOrganizationsRouteWithChildren =
  AuthenticatedManagementOrganizationsRoute._addFileChildren(
    AuthenticatedManagementOrganizationsRouteChildren,
  )

interface AuthenticatedManagementProfileRouteChildren {
  AuthenticatedManagementProfileIndexRoute: typeof AuthenticatedManagementProfileIndexRoute
}

const AuthenticatedManagementProfileRouteChildren: AuthenticatedManagementProfileRouteChildren =
  {
    AuthenticatedManagementProfileIndexRoute:
      AuthenticatedManagementProfileIndexRoute,
  }

const AuthenticatedManagementProfileRouteWithChildren =
  AuthenticatedManagementProfileRoute._addFileChildren(
    AuthenticatedManagementProfileRouteChildren,
  )

interface AuthenticatedManagementStationlessParkAndRideFacilityIdRouteChildren {
  AuthenticatedManagementStationlessParkAndRideFacilityIdAuditsRoute: typeof AuthenticatedManagementStationlessParkAndRideFacilityIdAuditsRoute
  AuthenticatedManagementStationlessParkAndRideFacilityIdIndexRoute: typeof AuthenticatedManagementStationlessParkAndRideFacilityIdIndexRoute
}

const AuthenticatedManagementStationlessParkAndRideFacilityIdRouteChildren: AuthenticatedManagementStationlessParkAndRideFacilityIdRouteChildren =
  {
    AuthenticatedManagementStationlessParkAndRideFacilityIdAuditsRoute:
      AuthenticatedManagementStationlessParkAndRideFacilityIdAuditsRoute,
    AuthenticatedManagementStationlessParkAndRideFacilityIdIndexRoute:
      AuthenticatedManagementStationlessParkAndRideFacilityIdIndexRoute,
  }

const AuthenticatedManagementStationlessParkAndRideFacilityIdRouteWithChildren =
  AuthenticatedManagementStationlessParkAndRideFacilityIdRoute._addFileChildren(
    AuthenticatedManagementStationlessParkAndRideFacilityIdRouteChildren,
  )

interface AuthenticatedManagementStationlessRouteChildren {
  AuthenticatedManagementStationlessParkAndRideFacilityIdRoute: typeof AuthenticatedManagementStationlessParkAndRideFacilityIdRouteWithChildren
  AuthenticatedManagementStationlessCreateRoute: typeof AuthenticatedManagementStationlessCreateRoute
  AuthenticatedManagementStationlessIndexRoute: typeof AuthenticatedManagementStationlessIndexRoute
}

const AuthenticatedManagementStationlessRouteChildren: AuthenticatedManagementStationlessRouteChildren =
  {
    AuthenticatedManagementStationlessParkAndRideFacilityIdRoute:
      AuthenticatedManagementStationlessParkAndRideFacilityIdRouteWithChildren,
    AuthenticatedManagementStationlessCreateRoute:
      AuthenticatedManagementStationlessCreateRoute,
    AuthenticatedManagementStationlessIndexRoute:
      AuthenticatedManagementStationlessIndexRoute,
  }

const AuthenticatedManagementStationlessRouteWithChildren =
  AuthenticatedManagementStationlessRoute._addFileChildren(
    AuthenticatedManagementStationlessRouteChildren,
  )

interface AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdRouteChildren {
  AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdAuditsRoute: typeof AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdAuditsRoute
  AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdIndexRoute: typeof AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdIndexRoute
}

const AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdRouteChildren: AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdRouteChildren =
  {
    AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdAuditsRoute:
      AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdAuditsRoute,
    AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdIndexRoute:
      AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdIndexRoute,
  }

const AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdRouteWithChildren =
  AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdRoute._addFileChildren(
    AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdRouteChildren,
  )

interface AuthenticatedManagementStationsStationIdRouteChildren {
  AuthenticatedManagementStationsStationIdAuditsRoute: typeof AuthenticatedManagementStationsStationIdAuditsRoute
  AuthenticatedManagementStationsStationIdIndexRoute: typeof AuthenticatedManagementStationsStationIdIndexRoute
  AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdRoute: typeof AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdRouteWithChildren
  AuthenticatedManagementStationsStationIdParkAndRideFacilitiesCreateRoute: typeof AuthenticatedManagementStationsStationIdParkAndRideFacilitiesCreateRoute
}

const AuthenticatedManagementStationsStationIdRouteChildren: AuthenticatedManagementStationsStationIdRouteChildren =
  {
    AuthenticatedManagementStationsStationIdAuditsRoute:
      AuthenticatedManagementStationsStationIdAuditsRoute,
    AuthenticatedManagementStationsStationIdIndexRoute:
      AuthenticatedManagementStationsStationIdIndexRoute,
    AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdRoute:
      AuthenticatedManagementStationsStationIdParkAndRideFacilitiesParkAndRideFacilityIdRouteWithChildren,
    AuthenticatedManagementStationsStationIdParkAndRideFacilitiesCreateRoute:
      AuthenticatedManagementStationsStationIdParkAndRideFacilitiesCreateRoute,
  }

const AuthenticatedManagementStationsStationIdRouteWithChildren =
  AuthenticatedManagementStationsStationIdRoute._addFileChildren(
    AuthenticatedManagementStationsStationIdRouteChildren,
  )

interface AuthenticatedManagementStationsRouteChildren {
  AuthenticatedManagementStationsStationIdRoute: typeof AuthenticatedManagementStationsStationIdRouteWithChildren
  AuthenticatedManagementStationsCreateRoute: typeof AuthenticatedManagementStationsCreateRoute
  AuthenticatedManagementStationsIndexRoute: typeof AuthenticatedManagementStationsIndexRoute
}

const AuthenticatedManagementStationsRouteChildren: AuthenticatedManagementStationsRouteChildren =
  {
    AuthenticatedManagementStationsStationIdRoute:
      AuthenticatedManagementStationsStationIdRouteWithChildren,
    AuthenticatedManagementStationsCreateRoute:
      AuthenticatedManagementStationsCreateRoute,
    AuthenticatedManagementStationsIndexRoute:
      AuthenticatedManagementStationsIndexRoute,
  }

const AuthenticatedManagementStationsRouteWithChildren =
  AuthenticatedManagementStationsRoute._addFileChildren(
    AuthenticatedManagementStationsRouteChildren,
  )

interface AuthenticatedManagementUsersUserIdRouteChildren {
  AuthenticatedManagementUsersUserIdIndexRoute: typeof AuthenticatedManagementUsersUserIdIndexRoute
}

const AuthenticatedManagementUsersUserIdRouteChildren: AuthenticatedManagementUsersUserIdRouteChildren =
  {
    AuthenticatedManagementUsersUserIdIndexRoute:
      AuthenticatedManagementUsersUserIdIndexRoute,
  }

const AuthenticatedManagementUsersUserIdRouteWithChildren =
  AuthenticatedManagementUsersUserIdRoute._addFileChildren(
    AuthenticatedManagementUsersUserIdRouteChildren,
  )

interface AuthenticatedManagementUsersRouteChildren {
  AuthenticatedManagementUsersUserIdRoute: typeof AuthenticatedManagementUsersUserIdRouteWithChildren
  AuthenticatedManagementUsersIndexRoute: typeof AuthenticatedManagementUsersIndexRoute
}

const AuthenticatedManagementUsersRouteChildren: AuthenticatedManagementUsersRouteChildren =
  {
    AuthenticatedManagementUsersUserIdRoute:
      AuthenticatedManagementUsersUserIdRouteWithChildren,
    AuthenticatedManagementUsersIndexRoute:
      AuthenticatedManagementUsersIndexRoute,
  }

const AuthenticatedManagementUsersRouteWithChildren =
  AuthenticatedManagementUsersRoute._addFileChildren(
    AuthenticatedManagementUsersRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedManagementOrganizationsRoute: typeof AuthenticatedManagementOrganizationsRouteWithChildren
  AuthenticatedManagementProfileRoute: typeof AuthenticatedManagementProfileRouteWithChildren
  AuthenticatedManagementStationlessRoute: typeof AuthenticatedManagementStationlessRouteWithChildren
  AuthenticatedManagementStationsRoute: typeof AuthenticatedManagementStationsRouteWithChildren
  AuthenticatedManagementUsersRoute: typeof AuthenticatedManagementUsersRouteWithChildren
  AuthenticatedManagementIndexRoute: typeof AuthenticatedManagementIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedManagementOrganizationsRoute:
    AuthenticatedManagementOrganizationsRouteWithChildren,
  AuthenticatedManagementProfileRoute:
    AuthenticatedManagementProfileRouteWithChildren,
  AuthenticatedManagementStationlessRoute:
    AuthenticatedManagementStationlessRouteWithChildren,
  AuthenticatedManagementStationsRoute:
    AuthenticatedManagementStationsRouteWithChildren,
  AuthenticatedManagementUsersRoute:
    AuthenticatedManagementUsersRouteWithChildren,
  AuthenticatedManagementIndexRoute: AuthenticatedManagementIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface PublicLegalRouteChildren {
  PublicLegalAboutLazyRoute: typeof PublicLegalAboutLazyRoute
  PublicLegalAccessibilityLazyRoute: typeof PublicLegalAccessibilityLazyRoute
  PublicLegalContactLazyRoute: typeof PublicLegalContactLazyRoute
  PublicLegalFrequentlyAskedQuestionsLazyRoute: typeof PublicLegalFrequentlyAskedQuestionsLazyRoute
  PublicLegalImprintLazyRoute: typeof PublicLegalImprintLazyRoute
  PublicLegalPrivacyLazyRoute: typeof PublicLegalPrivacyLazyRoute
  PublicLegalTermsOfUseLazyRoute: typeof PublicLegalTermsOfUseLazyRoute
}

const PublicLegalRouteChildren: PublicLegalRouteChildren = {
  PublicLegalAboutLazyRoute: PublicLegalAboutLazyRoute,
  PublicLegalAccessibilityLazyRoute: PublicLegalAccessibilityLazyRoute,
  PublicLegalContactLazyRoute: PublicLegalContactLazyRoute,
  PublicLegalFrequentlyAskedQuestionsLazyRoute:
    PublicLegalFrequentlyAskedQuestionsLazyRoute,
  PublicLegalImprintLazyRoute: PublicLegalImprintLazyRoute,
  PublicLegalPrivacyLazyRoute: PublicLegalPrivacyLazyRoute,
  PublicLegalTermsOfUseLazyRoute: PublicLegalTermsOfUseLazyRoute,
}

const PublicLegalRouteWithChildren = PublicLegalRoute._addFileChildren(
  PublicLegalRouteChildren,
)

interface PublicMapSidebarRouteChildren {
  PublicMapSidebarParkAndRideFacilitiesParkAndRideFacilityIdRoute: typeof PublicMapSidebarParkAndRideFacilitiesParkAndRideFacilityIdRoute
  PublicMapSidebarParkingFacilitiesParkingFacilityIdRoute: typeof PublicMapSidebarParkingFacilitiesParkingFacilityIdRoute
  PublicMapSidebarPickupParkingFacilitiesPickupParkingFacilityIdRoute: typeof PublicMapSidebarPickupParkingFacilitiesPickupParkingFacilityIdRoute
  PublicMapSidebarStationsStationIdRoute: typeof PublicMapSidebarStationsStationIdRoute
}

const PublicMapSidebarRouteChildren: PublicMapSidebarRouteChildren = {
  PublicMapSidebarParkAndRideFacilitiesParkAndRideFacilityIdRoute:
    PublicMapSidebarParkAndRideFacilitiesParkAndRideFacilityIdRoute,
  PublicMapSidebarParkingFacilitiesParkingFacilityIdRoute:
    PublicMapSidebarParkingFacilitiesParkingFacilityIdRoute,
  PublicMapSidebarPickupParkingFacilitiesPickupParkingFacilityIdRoute:
    PublicMapSidebarPickupParkingFacilitiesPickupParkingFacilityIdRoute,
  PublicMapSidebarStationsStationIdRoute:
    PublicMapSidebarStationsStationIdRoute,
}

const PublicMapSidebarRouteWithChildren =
  PublicMapSidebarRoute._addFileChildren(PublicMapSidebarRouteChildren)

interface PublicMapRouteChildren {
  PublicMapSidebarRoute: typeof PublicMapSidebarRouteWithChildren
  PublicMapIndexRoute: typeof PublicMapIndexRoute
}

const PublicMapRouteChildren: PublicMapRouteChildren = {
  PublicMapSidebarRoute: PublicMapSidebarRouteWithChildren,
  PublicMapIndexRoute: PublicMapIndexRoute,
}

const PublicMapRouteWithChildren = PublicMapRoute._addFileChildren(
  PublicMapRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  PublicLegalRoute: PublicLegalRouteWithChildren,
  PublicMapRoute: PublicMapRouteWithChildren,
  PublicAuthenticationLoginRoute: PublicAuthenticationLoginRoute,
  PublicAuthenticationInvitationAuthenticationTokenIdRoute:
    PublicAuthenticationInvitationAuthenticationTokenIdRoute,
  PublicAuthenticationPasswordResetAuthenticationTokenIdRoute:
    PublicAuthenticationPasswordResetAuthenticationTokenIdRoute,
  PublicAuthenticationPasswordResetIndexRoute:
    PublicAuthenticationPasswordResetIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
